export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/rust-service-stack-form';
